import { render } from "./UserAndMessages.vue?vue&type=template&id=23ddfb96&lang=pug"
import script from "./UserAndMessages.vue?vue&type=script&lang=js"
export * from "./UserAndMessages.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adolforeyna/Projects/EMI/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__